import React, { useEffect, useRef } from 'react';
import './AdBanner.css';

// ── Google AdSense ──
// El script de AdSense (adsbygoogle.js) se carga una sola vez desde public/index.html,
// junto con la meta google-adsense-account. Además de estos bloques, AdSense puede mostrar
// anuncios automáticos (Auto ads) si están activados en el panel.
//
// Ubicaciones (cada una con su bloque de AdSense):
//   top        → debajo del Navbar, en todas las páginas (bloque "horizontal")
//   game       → debajo del área de juego, en las pantallas de partida (bloque "displayAD").
//                Va SEPARADO del tablero y los botones (ver .fg-content-slot--game): la
//                política de AdSense para juegos pide distancia para evitar clicks accidentales.
//   rail-left / rail-right → columnas a los costados durante la partida (bloque "vertical").
//                Solo en pantallas muy anchas, donde quedan lejos del tablero; en el resto no
//                se renderizan (un bloque oculto con display:none igual le pide anuncio a
//                AdSense y tira error de tamaño).
// Con el slot vacío no se renderiza nada (así no queda un hueco vacío).
//
// Los anuncios no se recargan al empezar otra partida: AdSense no permite refrescarlos sin
// que el usuario navegue.
// Se sacó Adsterra: sus anuncios redirigían a sitios de apuestas y AdSense lo marca
// como "Site Behavior: Navigation" (navegación engañosa).
// En staging no se muestra publicidad.

const AD_CLIENT = 'ca-pub-3839541336007366';

const SLOT_HORIZONTAL = '1280761766';
const SLOT_DISPLAY    = '4838557343';
const SLOT_VERTICAL   = '9599993070';
// Bloque "cuadrado" (3473568421): creado en AdSense, todavía sin ubicación asignada.

// Ancho mínimo para las columnas laterales: layout de juego (1100px) + 150px de aire + 160px
// de anuncio, a cada lado. Mantener en sincronía con el @media de AdBanner.css.
const RAIL_MIN_WIDTH = 1720;

const PLACEMENTS = {
    // banner: tamaño fijo de banner (ver .fg-ad-banner) en vez de "auto". Con "auto", en
    // celular Google elegía un rectángulo de ~280px de alto y tapaba toda la parte de arriba.
    top:          { slot: SLOT_HORIZONTAL, banner: true },
    // Igual que top, pero en pantallas de partida: solo en desktop (en celular el layout
    // apila los controles del juego justo debajo y quedaría pegado a ellos).
    'top-game':   { slot: SLOT_HORIZONTAL, banner: true, minWidth: 861, className: 'top' },
    game:         { slot: SLOT_DISPLAY },
    'rail-left':  { slot: SLOT_VERTICAL, minWidth: RAIL_MIN_WIDTH, fixedWidth: true },
    'rail-right': { slot: SLOT_VERTICAL, minWidth: RAIL_MIN_WIDTH, fixedWidth: true },
};

const adsDisabled = () => /staging|localhost/i.test(window.location.hostname);

function AdBanner({ placement = 'top' }) {
    const pushed = useRef(false);
    const config = PLACEMENTS[placement] || {};
    const enabled = Boolean(config.slot)
        && !adsDisabled()
        && (!config.minWidth || window.innerWidth >= config.minWidth);

    useEffect(() => {
        if (!enabled || pushed.current) return;
        pushed.current = true;
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            // Bloqueador de anuncios o script todavía no cargado: no rompe la página.
        }
    }, [enabled]);

    if (!enabled) return null;
    return (
        <div className={`fg-content-slot fg-content-slot--${config.className || placement}`}>
            {config.banner ? (
                // Tamaño por CSS y sin data-ad-format: así AdSense respeta el alto del banner.
                <ins
                    className="adsbygoogle fg-ad-banner"
                    data-ad-client={AD_CLIENT}
                    data-ad-slot={config.slot}
                />
            ) : (
                <ins
                    className="adsbygoogle"
                    style={{ display: 'block', width: '100%' }}
                    data-ad-client={AD_CLIENT}
                    data-ad-slot={config.slot}
                    data-ad-format="auto"
                    data-full-width-responsive={config.fixedWidth ? 'false' : 'true'}
                />
            )}
        </div>
    );
}

export default AdBanner;
